const UNSUPPORTED_GDAD_ROLES = new Set([
  'solution architect',
  'chief data officer',
  'chief digital and information officer',
  'chief information security officer',
  'chief technology officer',
  'analytics engineer',
  'data ethicist',
  'digital evaluator',
  'machine learning engineer',
  'application operations engineer',
  'frontend developer',
]);

const normalizeRole = (role: unknown): string =>
  typeof role === 'string' ? role.trim().toLowerCase() : '';

export const isUnsupportedGdadRole = (role: unknown): boolean =>
  UNSUPPORTED_GDAD_ROLES.has(normalizeRole(role));

export const getUnsupportedGdadRoleBannerMessage = (role: unknown): string | null => {
  if (typeof role !== 'string') return null;
  const trimmedRole = role.trim();
  if (!trimmedRole || !isUnsupportedGdadRole(trimmedRole)) return null;

  return `The role '${trimmedRole}' is not supported by Cabinet Office GDAD policy. Please re-select a supported GDAD role via the 'Role Selection' screen`;
};

